import { OutputDataModalAction } from '../OutputDataDirectory';
import { TimeSeriesCalculationModal } from '../timeSeriesModals/TimeSeriesCalculationModal';
import { TimeSeriesConfirmationModal } from '../timeSeriesModals/TimeSeriesConfirmationModal';
import { TimeSeriesValidationModal } from '../timeSeriesModals/TimeSeriesValidationModal';
import { CalculationModal } from './CalculationModal';
import { CancelErrorsModal } from './CancelErrorsModal';
import { ConfirmationModal } from './ConfirmationModal';
import { ConfirmationsModal } from './ConfirmationsModal';
import { DeletionModal } from './DeletionModal';
import { RelatedOutputsModal } from './RelatedOutputsModal';
import { RelationsTablesModal } from '../../relations/RelationsTablesModal';
import { ValidationModal } from './ValidationModal';

export function renderOutputDataActionModal(
  action: OutputDataModalAction,
  onClose: () => void,
) {
  switch (action.type) {
    case 'showRelated':
      return <RelatedOutputsModal params={action.params} onClose={onClose} />;
    case 'showConfirmations':
      return <ConfirmationsModal params={action.params} onClose={onClose} />;
    case 'calculate':
      return <CalculationModal params={action.params} onClose={onClose} />;
    case 'validate':
      return <ValidationModal params={action.params} onClose={onClose} />;
    case 'calculateAndValidate':
      return (
        <CalculationModal params={action.params} onClose={onClose} validate />
      );
    case 'cancelCalculationErrors':
      return <CancelErrorsModal params={action.params} onClose={onClose} />;
    case 'confirm':
      return <ConfirmationModal params={action.params} onClose={onClose} />;
    case 'confirmAndCalculate':
      return (
        <ConfirmationModal
          params={action.params}
          onClose={onClose}
          mode="calculate"
        />
      );
    case 'changeConfirmStatus':
      return (
        <ConfirmationModal
          params={action.params}
          onClose={onClose}
          mode="edit"
        />
      );
    case 'openRelationsTable':
      return <RelationsTablesModal params={action.params} onClose={onClose} />;
    case 'delete':
      return <DeletionModal params={action.params} onClose={onClose} />;
    case 'timeSeriesCalculate':
      return <TimeSeriesCalculationModal onClose={onClose} />;
    case 'timeSeriesCalculateAndValidate':
      return <TimeSeriesCalculationModal onClose={onClose} validate />;
    case 'timeSeriesValidate':
      return <TimeSeriesValidationModal onClose={onClose} />;
    case 'timeSeriesConfirm':
      return <TimeSeriesConfirmationModal mode="default" onClose={onClose} />;
    case 'timeSeriesConfirmAndCalculate':
      return <TimeSeriesConfirmationModal mode="calculate" onClose={onClose} />;
    case 'timeSeriesChangeConfirmStatus':
      return <TimeSeriesConfirmationModal mode="edit" onClose={onClose} />;
    default:
      return null;
  }
}
